import axios from "axios";

// Defina REACT_APP_API_URL (ex.: http://localhost:3002) para apontar para outra API.
const getApi = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "https://rivierafc-api.onrender.com",
});

async function post(url, body, config) {
  await addToken(getApi)
  return getApi.post(url, body, config)
}

async function get(url, body) {
  await addToken(getApi)
 return getApi.get(url, body)
}

async function put(url, body) {
  await addToken(getApi)
  return getApi.put(url, body)
}

async function remove(url, body) {
  await addToken(getApi)
  return  getApi.delete(url, body)
}

// Envia um arquivo como multipart/form-data no campo "file".
async function upload(url, file, fields = {}) {
  await addToken(getApi)
  const data = new FormData();
  data.append("file", file);
  Object.entries(fields).forEach(([key, value]) => data.append(key, value));
  return getApi.post(url, data, { headers: { "Content-Type": "multipart/form-data" } })
}

async function addToken(api) {
  const storedToken = JSON.parse(localStorage.getItem('token'));
  if (storedToken && storedToken !== "\"\"") {
    api.defaults.headers.common['Authorization'] = `Bearer ${storedToken}`;
  } else {
    delete api.defaults.headers.common['Authorization'];
  }
  return api;
}


export default ({getApi,post, get,remove,put,upload});
